<!--
File: fascicle-list.component.html
Project: catalog-cloud
File Created: Wednesday, 22nd December 2021 12:48:17
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Monday, 16th March 2026 12:44:33 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->
<p-progressBar mode="indeterminate" *ngIf="loading"></p-progressBar>

<div class="table-fascicles-container">
  <div class="cc-page-header">
        <div class="cc-page-header-title">
          <i class="pi pi-images"></i>
          <span>{{ 'FASCICLE.LIST_TITLE' | translate }}</span>
          <span class="cc-page-header-subtitle" *ngIf="catalogName">— {{ catalogName }}</span>
        </div>
        <div class="cc-page-header-actions">
          <p-button
            icon="pi pi-plus"
            [label]="'FASCICLE.CREATE' | translate"
            severity="primary"
            size="small"
            (click)="newFascicle()"
          ></p-button>
          <p-button
            icon="pi pi-sparkles"
            [label]="'FASCICLE.AUTOMATIC_GENERATION' | translate"
            severity="secondary"
            [outlined]="true"
            size="small"
            (click)="generateFascicle()"
          ></p-button>
          <span class="cc-page-header-divider"></span>
          <p-button
            icon="pi pi-list"
            severity="secondary"
            [text]="true"
            size="small"
            [pTooltip]="'CATALOG.INDEX' | translate"
            tooltipPosition="bottom"
            [routerLink]="['/catalog', idCatalog, 'index']"
          ></p-button>
          <p-button
            icon="pi pi-refresh"
            severity="secondary"
            [text]="true"
            size="small"
            [pTooltip]="'FASCICLE.REFRESH' | translate"
            tooltipPosition="bottom"
            (click)="loadFascicles()"
          ></p-button>
          <p-button
            icon="pi pi-file-export"
            severity="secondary"
            [text]="true"
            size="small"
            [pTooltip]="'FASCICLE.EXPORT_SYNCWALL' | translate"
            tooltipPosition="bottom"
            (click)="exportToSyncWall()"
          ></p-button>
          <p-button
            icon="pi pi-download"
            severity="secondary"
            [text]="true"
            size="small"
            [pTooltip]="'FASCICLE.EXPORT_CSV' | translate"
            tooltipPosition="bottom"
            (click)="exportToCSV()"
          ></p-button>
        </div>
  </div>

  <p-table
      [value]="dataSource"
      styleClass="p-datatable p-datatable-striped p-datatable-sm"
      (onRowReorder)="reOrderFascicle($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 2.5rem"></th>
          <th>{{ "NAME" | translate }}</th>
          <th class="text-center">{{ "PAGES" | translate }}</th>
          <th class="text-center" style="width: 4rem">{{ "POSITION" | translate }}</th>
          <th>{{ "CREATED_BY" | translate }}</th>
          <th>{{ "UPDATED_AT" | translate }}</th>
          <th>{{ "ACTIONS" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-fascicle let-index="rowIndex">
        <tr [pReorderableRow]="index">
          <td pReorderableRowHandle class="drag-handle">
            <i class="pi pi-bars"></i>
          </td>
          <td
            *ngIf="
              fascicle.blocked ||
              (fascicle.blockedBy && fascicle.blockedBy.id != user.id)
            "
          >
            <p class="fascicle-name-text">{{ fascicle.name }}</p>
            <div class="fascicle-chips" *ngIf="resolvedChips(fascicle.categories, categoryMap).length || resolvedChips(fascicle.tags, tagMap).length">
              <span class="fascicle-chip fascicle-chip--category" *ngFor="let cat of resolvedChips(fascicle.categories, categoryMap)">{{ cat }}</span>
              <span class="fascicle-chip fascicle-chip--tag" *ngFor="let tag of resolvedChips(fascicle.tags, tagMap)">{{ tag }}</span>
            </div>
          </td>
          <td
            *ngIf="
              !fascicle.blocked &&
              (!fascicle.blockedBy || fascicle.blockedBy.id == user.id)
            "
          >
            <a
              class="fascicle-title"
              routerLink="/catalog/{{ idCatalog }}/fascicle/{{ fascicle.id }}"
              >{{ fascicle.name }}</a
            >
            <div class="fascicle-chips" *ngIf="resolvedChips(fascicle.categories, categoryMap).length || resolvedChips(fascicle.tags, tagMap).length">
              <span class="fascicle-chip fascicle-chip--category" *ngFor="let cat of resolvedChips(fascicle.categories, categoryMap)">{{ cat }}</span>
              <span class="fascicle-chip fascicle-chip--tag" *ngFor="let tag of resolvedChips(fascicle.tags, tagMap)">{{ tag }}</span>
            </div>
          </td>
          <td class="text-center">{{ fascicle.fromto }}</td>
          <td class="text-center">{{ fascicle.position }}</td>
          <td>
            {{ fascicle.createdBy?.name }}
            {{ fascicle.createdBy?.surname }}
          </td>
          <td>
            <span>{{ fascicle.updatedAt | date : "dd MMM YYYY HH:mm" }}</span>
          </td>
          <td>
            <!-- Mismo usuario: botón "Abrir en esta ventana" -->
            <ng-container *ngIf="fascicle.blocked && isSameUserBlock(fascicle)">
              <p-button
                [label]="'FASCICLE.OPEN_HERE' | translate"
                icon="pi pi-arrow-right-arrow-left"
                severity="secondary"
                [outlined]="true"
                size="small"
                (onClick)="takeOverFascicle(fascicle)"
              />
            </ng-container>

            <!-- Otro usuario bloqueando: mensaje de bloqueo -->
            <div *ngIf="fascicle.blocked && !isSameUserBlock(fascicle)" class="fascicle-blocked">
              <span>{{ "FASCICLE.BLOCKED_BY" | translate }}: </span>
              <span class="font-bold mr-2">{{ getBlockedByDisplay(fascicle) }}</span>
              <p-button
                (click)="requestUnBlock(fascicle)"
                icon="pi pi-lock-open"
                severity="danger"
                [text]="true"
                size="small"
              ></p-button>
            </div>

            <!-- No bloqueado: botones de edición -->
            <ng-container *ngIf="!fascicle.blocked">
              <div class="fascicle-action-group">
                <p-button
                  icon="pi pi-pencil"
                  size="small"
                  [text]="true"
                  severity="secondary"
                  [pTooltip]="'FASCICLE.EDIT' | translate"
                  tooltipPosition="top"
                  (onClick)="goToFascicle(fascicle.id)"
                />
                <p-button
                  icon="pi pi-cog"
                  size="small"
                  [text]="true"
                  severity="secondary"
                  [pTooltip]="'FASCICLE.EDIT_PROPERTIES' | translate"
                  tooltipPosition="top"
                  (onClick)="openFascicleSettings(fascicle.id)"
                />
                <p-button
                  icon="pi pi-clone"
                  size="small"
                  [text]="true"
                  severity="secondary"
                  [pTooltip]="'FASCICLE.CLONE' | translate"
                  tooltipPosition="top"
                  (onClick)="clone(fascicle.id)"
                />
                <p-button
                  icon="pi pi-trash"
                  size="small"
                  [text]="true"
                  severity="danger"
                  [pTooltip]="'FASCICLE.DELETE' | translate"
                  tooltipPosition="top"
                  (onClick)="delete(fascicle.id, idCatalog)"
                />
              </div>
            </ng-container>
          </td>
          <!-- <td class="text-center fascicle-position-cell">{{ fascicle.position }}</td> -->
        </tr>
      </ng-template>
  </p-table>
  <div class="list-empty-state" *ngIf="!loading && (!dataSource || dataSource.length === 0)">
    <i class="pi pi-images"></i>
    <p>{{ 'FASCICLE.EMPTY_MSG' | translate }}</p>
    <p-button
      icon="pi pi-plus"
      [label]="'FASCICLE.CREATE' | translate"
      severity="primary"
      (click)="newFascicle()"
    ></p-button>
  </div>
</div>
<p-confirmDialog
  key="deleteFascicleConfirm"
  [position]="'center'"
  rejectButtonStyleClass="'p-button-danger'"
></p-confirmDialog>

<p-confirmDialog
  key="cloneFascicleConfirm"
  [position]="'center'"
  rejectButtonStyleClass="'p-button-danger'"
></p-confirmDialog>

<p-confirmDialog
  key="exportCsvConfirm"
  [position]="'center'"
  [appendTo]="'body'"
  rejectButtonStyleClass="'p-button-danger'"
></p-confirmDialog>

<p-dialog
  [(visible)]="unblockDialogVisible"
  [closable]="false"
  [modal]="true"
  [style]="{ width: '340px' }"
  [header]="'FASCICLE.UNBLOCK_WAITING_TITLE' | translate"
  [draggable]="false"
  [resizable]="false"
>
  <div class="unblock-waiting-content">
    <p class="unblock-waiting-msg">{{ 'FASCICLE.UNBLOCK_WAITING_MSG' | translate }}</p>
    <div class="unblock-bar">
      <div class="unblock-bar-fill" *ngIf="unblockDialogVisible"></div>
    </div>
  </div>
</p-dialog>
